module.exports = __webpack_public_path__ + "img/banner.6a0d5e26.png";